import Vue from 'vue'
import Router from 'vue-router'
// import {apiAuthAccess} from "../common/utils";
import store from '@/store'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/adw/Dashboard.vue')
const Resource = () => import('@/views/adw/Resource.vue')
const Storage = () => import('@/views/adw/Storage.vue')

// 관리자 메뉴
const Account = () => import('@/views/adw/admin/Account.vue')
const Deployment = () => import('@/views/adw/admin/Deployment.vue')
const Container = () => import('@/views/adw/admin/Container.vue')
const ReqResource = () => import('@/views/adw/admin/ReqResource.vue')

const Login = () => import('@/views/adw/Login.vue');
const Credit = () => import('@/views/adw/pages/Credit.vue');
const Cards = () => import('@/views/base/Cards')

const UserInfo = () => import('../views/adw/setting/UserInfo');
const UserLog = () => import('../views/adw/setting/UserLog.vue');
const WorkerLog = () => import('../views/adw/setting/WorkerLog.vue');
// const AccessLog = () => import('../views/users/AccessLog');
// const AccessMap = () => import('../views/users/AccessMap');

const requireAuth = () => async (to, from, next) => {
  console.log( 'requireAuth()-------------> to-path ---->', to.path, store.state.user.isAuth );
  try {
    if(!store.state.user.isAuth){
      return next('/login')
    }else{
      console.debug('go to path:', to.path)
      return next();
    }
    /*
    const rs = await apiAuthAccess({path: to.path, name: to.name});
    console.log('requireAuth---apiAuthAccess return --->', rs);
    switch(rs.code){
      case 200: return next();
      case 8423: return alert(`[${rs.code}] 접근 권한이 없습니다.`);
      case 8424: return alert(`[${rs.code}] '${to.name}' 접근이 거부 되었습니다.`);
      case 7406:
        alert("[중복 로그인] 로그아웃 되었습니다.");
        return next('/login');
      default:
        alert( `[${rs.code}] 로그인이 필요합니다.`);
        return next('/login');
    }
    */

  }catch(err){
    console.error(err);
  }


};


Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          beforeEnter: requireAuth(),
          component: Dashboard
        },

        {
          path: 'resource',
          name: '분석환경_리소스',
          props: true,
          beforeEnter: requireAuth(),
          component: Resource
        },
        {
          path: 'storage',
          name: '저장소',
          beforeEnter: requireAuth(),
          component: Storage
        },
        {
          path: 'setting',
          redirect: '/setting/user-info',
          name: '환경설정',
          component: {
            render (c) { return c('router-view') }
          },
          children: [

            {
              path: 'user-info',
              name: '내정보',
              beforeEnter: requireAuth(),
              component: UserInfo
            },
            {
              path: 'user-mng',
              name: '사용자 관리',
              beforeEnter: requireAuth(),
              component: UserInfo
            }
          ]
        }
        ,
        {
          path: 'admin',
          redirect: '/admin/container',
          name: '관리자',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'account',
              name: '계정관리',
              beforeEnter: requireAuth(),
              component: Account
            },
            {
              path: 'deployment',
              name: '사용자 환경설정',
              beforeEnter: requireAuth(),
              component: Deployment
            },
            {
              path: 'req-resource',
              name: '리소스 요청관리',
              beforeEnter: requireAuth(),
              component: ReqResource
            },
            {
              path: 'container',
              name: '컨테이너관리',
              beforeEnter: requireAuth(),
              component: Container
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
          ]

        },

      ]
    },
    { path: '/login', name: 'Login', props: true, component: Login },
    { path: '/credit', name: 'Credit', props: false, component: Credit }
  ]
})
